import { useEffect } from "react";

const setMeta = (name, content, attr = "name") => {
    if (!content) return;
    let el = document.head.querySelector(`meta[${attr}="${name}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
};

const setCanonical = (href) => {
    if (!href) return;
    let el = document.head.querySelector('link[rel="canonical"]');
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", "canonical");
        document.head.appendChild(el);
    }
    el.setAttribute("href", href);
};

export const SEO = ({ title, description, canonical }) => {
    useEffect(() => {
        if (title) document.title = title;
        if (description) {
            setMeta("description", description);
            setMeta("og:description", description, "property");
            setMeta("twitter:description", description);
        }
        if (title) {
            setMeta("og:title", title, "property");
            setMeta("twitter:title", title);
        }
        if (canonical) {
            setCanonical(canonical);
            setMeta("og:url", canonical, "property");
        }
    }, [title, description, canonical]);
    return null;
};

export default SEO;
